




































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'editing-layout',
})
export default class DashboardLayout extends Vue {
  @Prop(String) title!: string;

  @Prop(String) subText!: string;

  @Prop({ type: String, default: 'Готово' }) buttonText!: string;

  @Prop({ type: Boolean, default: false }) light!: boolean;

  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  close(event: Event) {
    this.$emit('close', event);
  }

  submit(event: Event) {
    this.$emit('submit', event);
  }
}
